export function shortDisplayTitle(value, maxLength = 25) {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  if (!text || text.length <= maxLength) return text;

  const ellipsis = '...';
  const limit = Math.max(8, maxLength - ellipsis.length);
  const candidate = text.slice(0, limit + 1);
  const lastSpace = candidate.lastIndexOf(' ');
  const cut = lastSpace >= 10 ? lastSpace : limit;
  const shortened = text.slice(0, cut).replace(/[\s,.;:!?-]+$/g, '');
  return `${shortened}${ellipsis}`;
}
